import { useEffect, useState } from 'react';
import { apiFetch } from '../auth/apiClient';

export const attributedLabel = (label, name) => name ? `${label} — ${name}` : label;

export default function useReviewWorkflowAttribution(workflow) {
  const reviewerId = workflow?.rmReviewedByStaffProfileId ?? workflow?.rm_reviewed_by_staff_profile_id;
  const decisionMakerId = workflow?.nwacDecidedByStaffProfileId ?? workflow?.nwac_decided_by_staff_profile_id;
  const ids = [...new Set([reviewerId, decisionMakerId].map(Number)
    .filter(id => Number.isSafeInteger(id) && id > 0))].sort((a, b) => a - b).join(',');
  const [names, setNames] = useState({});
  useEffect(() => {
    if (!ids) return undefined;
    const controller = new AbortController();
    apiFetch(`/api/me/staff-profiles?ids=${encodeURIComponent(ids)}`, { signal: controller.signal })
      .then(response => response.ok ? response.json() : null)
      .then(result => {
        if (!controller.signal.aborted) {
          setNames(Object.fromEntries((result?.items || []).map(item => [item.id, item.displayName])));
        }
      })
      .catch(() => { if (!controller.signal.aborted) setNames({}); });
    return () => controller.abort();
  }, [ids]);
  return {
    reviewerName: names[reviewerId] || null,
    decisionMakerName: names[decisionMakerId] || null,
  };
}
